import './styles/App.css';
import Sidebar from './components/Sidebar.js';
import Login from './pages/Login.js';
import Dashboard from './pages/Dashboard.js';
import CreateBuilding from './pages/CreateBuilding.js';
import ListBuilding from './pages/ListBuilding.js';
import ListRole from './pages/ListRole.js';
import Logout from './pages/Logout.js';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { GuardProvider, GuardedRoute } from 'react-router-guards';
import { useState } from 'react';
import Auth, { evaluateAuth } from './guards/AuthProvider.js';
import "../src/styles/App.css";

function App() {
    const [auth, setAuth] = useState(null);

    return (
        <div className="app">
            <Auth.Provider value={[auth, setAuth]}>
                <BrowserRouter>
                    <GuardProvider guards={ [evaluateAuth(setAuth)] } error='Error...'>
                        <Switch>
                            <Route path='/login' exact component={Login} />
                            <>
                                <Sidebar />
                                <GuardedRoute path='/' exact component={Dashboard} />
                                <GuardedRoute path='/dashboard' component={Dashboard} />
                                <GuardedRoute path='/logout' component={Logout} />
                                <GuardedRoute path='/create_building' component={CreateBuilding} />
                                <GuardedRoute path='/list_building' component={ListBuilding} />
                                <GuardedRoute path='/list_role' component={ListRole} />
                            </>
                        </Switch>
                    </GuardProvider>
                </BrowserRouter>
            </Auth.Provider>
        </div>
    );
}

export default App;
